export default "__VITE_ASSET__BQzBkw6S__"